// src/App.js
import React, { useState, useEffect } from "react";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./Home";
import Login from "./Login";
import Settings from "./Settings";
import Contact from "./Contact";
import Register from "./Register";
import { apiUrl } from "./api";

function App() {
  const authEnabled = window.CONSILIA_AUTH_ENABLED === true;
  const [token, setToken] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [authPending, setAuthPending] = useState(authEnabled);
  const canEnter = !authEnabled || Boolean(token);

  // read login state from localStorage on first load
  useEffect(() => {
    if (!authEnabled) return;
    const savedToken = localStorage.getItem("authToken");
    if (!savedToken) {
      setAuthPending(false);
      return;
    }
    fetch(apiUrl("/api/me"), { headers: { Authorization: `Bearer ${savedToken}` } })
      .then(async (res) => {
        if (!res.ok) throw new Error("Session expired");
        const data = await res.json();
        setUserEmail(data.email);
        setToken(savedToken);
      })
      .catch(() => localStorage.removeItem("authToken"))
      .finally(() => setAuthPending(false));
  }, [authEnabled]);

  function handleLogin(email, newToken) {
    localStorage.setItem("authToken", newToken);
    setUserEmail(email);
    setToken(newToken);
  }

  function handleLogout() {
    localStorage.removeItem("authToken");
    setToken("");
    setUserEmail("");
  }

  if (authPending) return <div className="min-h-screen bg-slate-900 text-white p-6">Checking your session…</div>;

  return (
    <HashRouter>
      <Routes>
        {/* Login route */}
        <Route
          path="/login"
          element={
            canEnter ? (
              <Navigate to="/" replace />
            ) : (
              <Login onLogin={handleLogin} />
            )
          }
        />

        {/* Main chat (Home) */}
        <Route
          path="/"
          element={
            canEnter ? (
              <Home onLogout={handleLogout} userEmail={userEmail} authEnabled={authEnabled} token={token} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* Settings (protected) */}
        <Route
          path="/settings"
          element={
            canEnter ? (
              <Settings userEmail={userEmail} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* Contact (protected) */}
        <Route
          path="/contact"
          element={
            canEnter ? (
              <Contact userEmail={userEmail} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        
        <Route
  path="/register"
  element={canEnter ? <Navigate to="/" replace /> : <Register />}
/>

        {/* Fallback */}
        <Route
          path="*"
          element={<Navigate to={canEnter ? "/" : "/login"} replace />}
        />
      </Routes>
    </HashRouter>
  );
}

export default App;
